var exports = {
  "tp": "FeatureComparisonTable.module__table___aG05bC",
  "wx": "FeatureComparisonTable.module__header___aG05bC",
  "_j": "FeatureComparisonTable.module__headerFeature___aG05bC",
  "t_": "FeatureComparisonTable.module__headerFeatureText___aG05bC",
  "UE": "FeatureComparisonTable.module__headerValues___aG05bC",
  "LX": "FeatureComparisonTable.module__headerRestricted___aG05bC",
  "_b": "FeatureComparisonTable.module__headerStock___aG05bC",
  "Ge": "FeatureComparisonTable.module__rows___aG05bC",
};

module.exports = exports;
